// src/store/useAuthStore.ts
import { createStore } from "zustand";
import { useStore } from "zustand";
import { persist } from "zustand/middleware";
import type { InitialAuthState, AuthState } from "./types";

const initialState: InitialAuthState = {
  isLoggedIn: false,
  errorMessage: null,
  isLoading: false,
  user: null,
};

// Using persist middleware to keep auth state after page refresh
export const authStore = createStore<AuthState>()(
  persist(
    (set) => ({
      ...initialState,
      setLogin: (user) =>
        set({
          user,
          isLoggedIn: true,
          errorMessage: null,
          isLoading: false,
        }),
      setLogout: () =>
        set({
          user: null,
          isLoggedIn: false,
          errorMessage: null,
          isLoading: false,
        }),
      setError: (message) => set({ errorMessage: message }),
      setLoading: (loading) => set({ isLoading: loading }),
    }),
    {
      name: "auth-storage", // key for localStorage
      partialize: (state) => ({
        user: state.user,
        isLoggedIn: state.isLoggedIn,
      }),
    }
  )
);

export const useAuthStore = <T>(selector: (state: AuthState) => T) =>
  useStore(authStore, selector);
